// src/utils/extractRecipeJson.js
import JSON5 from "json5";

export function extractRecipeJson(content) {
  if (!content || typeof content !== "string") return null;

  // Match code block that looks like a recipe
  const match = content.match(/```(?:json|plaintext)?\s*({[\s\S]*?})\s*```/) || content.match(/{[\s\S]*}/);

  if (match) {
    try {
      const parsed = JSON5.parse(match[1] || match[0]);
      if (parsed?.name && parsed?.servings) {
        return parsed;
      }
    } catch (err) {
      console.warn("⚠️ Invalid JSON-like structure in recipe:", err.message);
    }
  }

  return null;
}
